'use client';

import { createContext, useContext } from 'react';

/**
 * Which arrival layout wraps the sign-up form, or false on every ordinary load.
 *
 * Both layouts (Labs, interview) show their own heading above the card and sit it on a cream
 * surface, so the form drops its generic heading and the card goes transparent for either. Only the
 * LABS arrival also changes the form's copy ("from your lab", names on one row, "Create account and
 * see my matches"). The interview arrival keeps the form exactly as shipped, so the live sign-up test
 * reads cleanly inside that cohort (QA-682: a plain boolean gave the interview panel the Labs copy).
 */
export type ArrivalLayout = 'interview' | 'labs';

export const LabsArrivalContext = createContext<ArrivalLayout | false>(false);

/** True inside the Labs arrival layout only. Keys the Labs-specific form copy. */
export function useIsLabsArrival(): boolean {
  return useContext(LabsArrivalContext) === 'labs';
}

/** True inside any arrival layout that carries the heading and the cream surface itself. */
export function useArrivalCarriesHeading(): boolean {
  return useContext(LabsArrivalContext) !== false;
}
